<template>
  <div :id="`wufoo-${form}`">
    <span class="text-muted">
      <i class="fa fa-circle-o-notch fa-spin mr-1"></i>
      Loading form...
    </span>
  </div>
</template>

<script>
export default {
  props: {
    username: {
      type: String,
      required: true
    },
    form: {
      type: String,
      required: true
    }
  },
  mounted () {
    let wufoo = null,
      d = document,
      t = 'script'

    let s = d.createElement(t),
      options = {
        'userName': this.username,
        'formHash': this.form,
        'autoResize': true,
        'height': '500',
        'async': true,
        'host': 'wufoo.com',
        'header': 'show',
        'ssl': true
      }

    s.src = ('https:' === d.location.protocol ? 'https://' : 'http://') + 'secure.wufoo.com/scripts/embed/form.js'
    s.onload = s.onreadystatechange = function () {
      let rs = this.readyState
      if (rs) {
        if (rs !== 'complete') {
          if (rs !== 'loaded') {
            return;
          }
        }
      }
      try {
        wufoo = new WufooForm();
        wufoo.initialize(options)
        wufoo.display()
      } catch (e) {
        console.error(e)
      }
    }
    let scr = d.getElementsByTagName(t)[0],
      par = scr.parentNode
    par.insertBefore(s, scr)
  }
}
</script>
